import { useRefreshSite } from "hooks/site.hook";
import PropTypes from "prop-types";
import React, { createContext, useMemo } from "react";
// eslint-disable-next-line import/no-cycle
import generateTemplatePropsFromContents from "utils/templatePropsUtils";

const SiteContext = createContext();
export default SiteContext;

export const SiteContextProvider = (props) => {
  const { site = {}, children = null } = props;
  const { data } = useRefreshSite();

  // il est possible de passer un site props, cas du back office
  let currentSite = useMemo(() => (typeof data === "object" && data.id && data) || site || {}, [data, site]);
  if (currentSite && currentSite.contents) {
    const contentsProps = generateTemplatePropsFromContents(currentSite.contents);
    currentSite = {
      ...contentsProps,
      ...currentSite,
    };
  }

  return <SiteContext.Provider value={currentSite}>{children}</SiteContext.Provider>;
};

SiteContextProvider.propTypes = {
  site: PropTypes.shape(),
  children: PropTypes.node,
};
